<template>
  <el-card>
    <el-button-group class="mb-3"><search-form :fields="search" /></el-button-group>

    <el-table :data="billBalanceLogs" resource="bill-balance-logs">
      <!-- <el-table-column prop="id" label="ID" width="60" /> -->
      <el-table-column prop="log_type_text" label="类型" width="100" />
      <el-table-column prop="amount" label="变动金额" />
      <el-table-column prop="before_amount" label="变动前" />
      <el-table-column prop="after_amount" label="变动后" />
      <el-table-column prop="order_id" label="订单号" width="190" />
      <el-table-column prop="recharge_id" label="充值编号" width="190" />
      <el-table-column prop="op_name" label="操作人" />
      <el-table-column prop="created_at" label="时间" width="170" />
      <el-table-column prop="remark" label="备注" />
    </el-table>
    <div class="card-footer"><pagination :page="page" /></div>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm';
import Pagination from '@c/Pagination';
import { getBillBalanceLogs } from '@/api/bill-balance-logs';

export default {
  name: 'UserBillBalanceLogs',
  components: {
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        // 0 管理员修改 1 订单支付 2 订单退款 3 审核充值
        {
          field: 'log_type',
          label: '类型',
          type: 'el-select',
          options: [{ id: 0, name: '管理员修改' }, { id: 1, name: '订单支付' }, { id: 2, name: '订单退款' }, { id: 3, name: '审核充值' }],
          labelField: 'name', // 默认为 name
          valueField: 'id' // 默认为 id
        },
        {
          field: 'order_id',
          label: '订单号'
        },
        {
          field: 'created_at',
          label: '获得时间',
          type: 'el-date-picker'
        }
      ],
      billBalanceLogs: [],
      page: null
    };
  },
  watch: {
    $route: {
      async handler(newVal) {
        newVal.query.user_id = this.$route.params['id'];
        const {
          data: { data, meta }
        } = await getBillBalanceLogs(newVal.query);
        this.billBalanceLogs = data;
        this.page = meta;
      },
      immediate: true
    }
  }
};
</script>
